import type { ProductColor } from '@aloft/toolkit-shared';
import { Flex, Tooltip, Typography } from '@aloft/toolkit-sui';

import {
  setReferenceViewOpen,
  setSelectedDataSheet,
} from '../../../redux/features/referenceBarUISlice.ts';
import { useAppDispatch } from '../../../redux/hooks.ts';
import { PropertyPinIcon } from '../../PropertyPin.tsx';
import type { PropertyPinStatus } from '../../Tkv2Map/types.ts';
import { ValuationTablePropertyHeaderDistanceToSubject } from './ValuationTablePropertyHeaderDistanceToSubject.tsx';

type ValuationTablePropertyHeaderTitleProps = {
  hideActions: boolean;
  pinColor: ProductColor;
  pinStatus: PropertyPinStatus;
  propertyId: string;
  title: string;
  hideDistanceToSubject?: boolean;
};

export const ValuationTablePropertyHeaderTitle = ({
  hideActions,
  pinColor,
  pinStatus,
  title,
  propertyId,
  hideDistanceToSubject,
}: ValuationTablePropertyHeaderTitleProps) => {
  const dispatch = useAppDispatch();

  const handleMapPinClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    // Setting the active id is already handled by the useTkv2ReferenceBarEvents hook
    dispatch(setSelectedDataSheet('mls-map'));
    dispatch(setReferenceViewOpen(true));
  };

  return (
    <Flex alignItems="center" whiteSpace="nowrap">
      <Flex gap="0.5rem" alignItems="center">
        <Tooltip openDelay={500} label={`${pinStatus}: View on map`} isDisabled={hideActions}>
          <Flex alignItems="center" justifyContent="center" position="relative">
            <PropertyPinIcon
              propertyId={propertyId}
              color={pinColor}
              text={pinStatus.charAt(0).toUpperCase()}
              onClick={hideActions ? undefined : handleMapPinClick}
            />
          </Flex>
        </Tooltip>
        <Typography variant="h3" __dangerDoNotUseSx={{ fontSize: '14px' }}>
          {title}
        </Typography>
        {!hideDistanceToSubject && (
          <ValuationTablePropertyHeaderDistanceToSubject propertyId={propertyId} />
        )}
      </Flex>
    </Flex>
  );
};
